import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ngb-alarm-recipient-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{name}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="InputEmail">Email address:</label>
          <input type="email" class="form-control" id="InputEmail" aria-describedby="emailHelp" placeholder="Enter email" value={{recipient.email}}>
        </div>
        <div class="form-group">
          <label for="InputUsername">User name:</label>            
          <input type="text" class="form-control" id="InputUsername" aria-describedby="userNameHelp" placeholder="Enter userName" value={{recipient.name}}>
        </div>
        <div class="form-group">
          <label for="InputAlarmType">Alarm Type:</label>
          <select class="form-control">
            <option value="RTM">RTM</option>
            <option value="slapmissing">SLAPMISSING</option>
            <option value="txt">TXT</option>
            <option value="weekly">WEEKLY</option>
            <option value="tdmap">TDMAP</option>
            <option value="abankmissing">ABANKMISSING</option>
          </select>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Save</button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel click')">Cancel</button>
    </div>  `
})
export class NgbAlarmRecipientModalContent {
  @Input() name;
  @Input() recipient;

  constructor(public activeModal: NgbActiveModal) { }
}
